import { useContext } from 'react';

import { EventContext } from '../components/Context';

export const useFeatureFlag = () => {
  const EVENT = useContext(EventContext);

  return EVENT.feature_flag ?? {};
};
